import { Component } from '@angular/core';

@Component({
  selector: 'app-update-neurology-visit',
  templateUrl: './update-neurology-visit.component.html',
  styleUrls: ['./update-neurology-visit.component.css']
})
export class UpdateNeurologyVisitComponent {

}
